import { ca } from '@cian/analytics';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { TProduct } from '../../types/product';

interface ITrackPromoLinkClickParams {
  product: TProduct;
  sc: IJsonQuery;
  label: 'to_offers' | 'to_jk' | 'to_listingjk';
}

/**
 * Отправка события открытия ссылки из модалки акции.
 * https://conf.cian.tech/pages/viewpage.action?pageId=1311539818
 * @param {ITrackPromoLinkClickParams} params - Параметры события
 */
export const trackPromoLinkClick = (params: ITrackPromoLinkClickParams) => {
  const { label, product, sc } = params;

  ca('eventSite', {
    action: 'Click',
    category: 'Promo',
    label,
    name: 'oldevent',
    products: [product],
    sc,
  });
};
